import React from "react";
import { Link } from "gatsby";
import { LogoText } from "./LogoText";
import { LogoSubText } from "./LogoSubText";
import { SubTextContainer } from "./SubTextContainer";
import { LogoContainer } from "./LogoContainer";

export function Logo() {
  return (
    <Link to="/">
      <LogoContainer>
        <LogoText color="#000000">w</LogoText>
        <SubTextContainer>
          <LogoText color="#01a8c6">Sołtysiak</LogoText>
          <LogoSubText>SQ3WSO</LogoSubText>
        </SubTextContainer>
        <LogoText color="#000000"> Blog</LogoText>
      </LogoContainer>
    </Link>
  );
}
